// react
import { useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// dialogs
import { DialogActions } from '../DialogActions/DialogActions';

// forms
import { FormUploadBeneficiaries } from '../../forms/FormUploadBeneficiaries/FormUploadBeneficiaries';

// props
export interface DialogUploadBeneficiariesProps {
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: () => void;
}

export const DialogUploadBeneficiaries = ({
	isOpen,
	onClose,
	onSuccess,
}: DialogUploadBeneficiariesProps) => {
	// hooks
	const { t } = useTranslation();

	// state
	const [isLoading, setIsLoading] = useState(false);

	return (
		<DialogActions
			actions={[
				{
					children: t('cancel'),
					onClick: onClose,
				},
				{
					children: t('uploadBeneficiaries'),
					form: 'form-upload-beneficiaries',
					loading: isLoading,
					type: 'submit',
					variant: 'contained',
				},
			]}
			hasClose={true}
			isOpen={isOpen}
			maxWidth={700}
			onClose={onClose}
			title={{
				children: t('uploadBeneficiaries'),
				variant: 'h3',
			}}>
			<FormUploadBeneficiaries
				onClose={onClose}
				onSuccess={onSuccess}
				setIsLoading={setIsLoading}
			/>
		</DialogActions>
	);
};
